var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9994 27C21.455 27 27.5 20.955 27.5 13.4994C27.5 6.04374 21.455 0 13.9994 0C6.54374 0 0.5 6.04374 0.5 13.4994C0.5 20.955 6.54374 27 13.9994 27ZM12.7296 7.01944C11.9119 7.01944 11.1634 7.48117 10.7977 8.21385L10.5134 8.78129C10.3919 9.02552 10.1428 9.17983 9.86938 9.17983H8.9593C7.7661 9.17983 6.80012 10.147 6.80012 11.339V17.819C6.80012 19.0122 7.7661 19.9793 8.9593 19.9793H19.0395C20.2327 19.9793 21.1999 19.0122 21.1999 17.819V11.339C21.1999 10.147 20.2327 9.17983 19.0395 9.17983H18.1294C17.8572 9.17983 17.6069 9.02552 17.4854 8.78129L17.2011 8.21385C16.8354 7.48117 16.0881 7.01944 15.2691 7.01944H12.7296ZM13.9994 12.0595C12.8062 12.0595 11.839 13.0267 11.839 14.2199C11.839 15.4119 12.8062 16.3791 13.9994 16.3791C15.1926 16.3791 16.1598 15.4119 16.1598 14.2199C16.1598 13.0267 15.1926 12.0595 13.9994 12.0595ZM10.3991 14.2199C10.3991 12.2309 12.0115 10.6197 13.9994 10.6197C15.9872 10.6197 17.5996 12.2309 17.5996 14.2199C17.5996 16.2078 15.9872 17.819 13.9994 17.819C12.0115 17.819 10.3991 16.2078 10.3991 14.2199Z",
    fill: "#2196F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.200f47209e7fd447bf77624155261c38.svg";
export { ForwardRef as ReactComponent };